export default "__VITE_ASSET__CQrlALML__"